import graphql__3ed6f66f2577070de8f7 from "./__generated__/SignUpAppRouteQuery.graphql.js";import { useCallback } from "react";
import { graphql } from "react-relay";

import AppInner from "../AppInner";
import AppQueryRenderer from "../AppQueryRenderer";
import AuthenticationSignUp from "../Authentication/AuthenticationSignUp";

const SignUpAppRoute = () => {
  const handleSignedIn = useCallback(() => (window.location.href = "/"), []);

  return (
    <AppInner>
      <AppQueryRenderer query={SignUpAppRouteQuery}>
        {({ authenticationConfig }) => (
          <AuthenticationSignUp
            onSignIn={handleSignedIn}
            authenticationConfig={authenticationConfig}
            withoutPadding
          />
        )}
      </AppQueryRenderer>
    </AppInner>
  );
};

const SignUpAppRouteQuery = graphql__3ed6f66f2577070de8f7;

export default SignUpAppRoute;
